import React, { useEffect, useRef, useState } from "react";
import "./Change_Profile_modal.css";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { AuthUpdate, GETAuthLogin } from "../../../../../features/auth/Slice";
import { FaCamera } from "react-icons/fa";
import { IDS } from "../../../../../utils/IDS";

function Change_Profile_modal({ ...props }) {
  const dispatch = useDispatch();
  const fileRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { name: "" },
  });

  useEffect(() => {
    if (props?.user) {
      reset(props?.user);
      if (props?.user?.profile_pic) setPreview(IDS.IMG_URL + props?.user?.profile_pic);
    }
  }, [props?.user]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setPreview(URL.createObjectURL(file)); // show local preview instantly
  };

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data?.name);
      if (imageFile) {
        formData.append("profile_pic", imageFile);
      }

      const res = await dispatch(AuthUpdate(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(GETAuthLogin());
        props.onHide();
        props?.setModalShow1(true);
        props?.setModalMessage("Profile Updated Successfully");
        setTimeout(() => props?.setModalShow1(false), 2000);
      } else {
        props?.setModalShow1(true);
        props?.setModalMessage(res?.payload?.errors);
        setTimeout(() => props?.setModalShow1(false), 2000);
        console.error("Update failed:", res.error);
      }
    } catch (error) {
      console.error("Update profile failed:", error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        centered
        size="sm"
        backdrop="static"
        className="Change_Profile_modal Common_modal"
        scrollable
      >
        <Modal.Body>
          <div className="upi_container">
            <div className="modal_header">Change Profile</div>
            <div className="box_holder login-page">
              <Form onSubmit={handleSubmit(onSubmit)} noValidate>

                {/* Profile Picture */}
                <div className="profile_pic_holder text-center mb-3">
                  <div
                    className="profile_pic_wrapper"
                    onClick={() => fileRef.current.click()}
                    style={{ position: "relative", display: "inline-block", cursor: "pointer" }}
                  >
                    <img
                      src={preview || "/assets/images/icons/user_placeholder.png"}
                      alt="profile"
                      className="profile_pic_preview"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "2px solid #ddd",
                      }}
                    />
                    {/* Camera overlay */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0",
                        right: "0",
                        background: "#fc5c5d",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaCamera style={{ color: "#fff", fontSize: "11px" }} />
                    </div>
                  </div>

                  {/* Hidden file input */}
                  <input
                    ref={fileRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <div style={{ fontSize: "11px", color: "#777f95", marginTop: "6px" }}>
                    Tap to change photo
                  </div>
                </div>



                <div className="btn_holder mt-5">
                  <Button
                    type="submit"
                    className="btn_register_bg mb-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Updating..." : "Update"}
                  </Button>
                  <Button className="btn-register" onClick={props.onHide}>
                    Close
                  </Button>
                </div>

              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Change_Profile_modal;